"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var FirebaseAPI = require("./FirebaseAPI");
module.exports = /*#__PURE__*/function (_FirebaseAPI) {
  (0, _inherits2["default"])(BaseFirebaseStorage, _FirebaseAPI);
  var _super = _createSuper(BaseFirebaseStorage);
  function BaseFirebaseStorage(firebase, pathConfig, baseUrl, plainToClassHook, classToPlainHook, classTransformOptions) {
    (0, _classCallCheck2["default"])(this, BaseFirebaseStorage);
    return _super.call(this, firebase, pathConfig, baseUrl, plainToClassHook, classToPlainHook, classTransformOptions);
  }
  (0, _createClass2["default"])(BaseFirebaseStorage, [{
    key: "getFileMetadata",
    value: function () {
      var _getFileMetadata = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(fullPath) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              throw new Error("getFileMetadata: not implemented");
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getFileMetadata(_x) {
        return _getFileMetadata.apply(this, arguments);
      }
      return getFileMetadata;
    }()
  }, {
    key: "setFileMetadata",
    value: function () {
      var _setFileMetadata = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(fullPath, metadata) {
        var fileRef;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.log("BaseFirebaseStorage: metadata = ", metadata, ", fullPath = ", fullPath);
              fileRef = this.refFromPath(fullPath);
              _context2.next = 4;
              return fileRef.setMetadata(metadata);
            case 4:
              return _context2.abrupt("return", _context2.sent);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function setFileMetadata(_x2, _x3) {
        return _setFileMetadata.apply(this, arguments);
      }
      return setFileMetadata;
    }()
  }, {
    key: "refFromPath",
    value: function refFromPath(path) {
      throw "BaseFirebaseStorage: refFromPath not implemented";
    }
  }]);
  return BaseFirebaseStorage;
}(FirebaseAPI);